/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Swiper from "vux/src/components/swiper/swiper.vue"; // this line is trasformed by vux-loader
import SwiperItem from "vux/src/components/swiper/swiper-item.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import { apiservicedetail, apibannerlist, getEnterprises } from '@/api';
export default {
  name: 'ServiceDetail',
  props: {
    id: [String, Number],
    title: String,
    productId: String,
    cpId: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    ViewBox: ViewBox,
    XButton: XButton,
    Swiper: Swiper,
    SwiperItem: SwiperItem
  },
  data: function data() {
    return {
      bannerList: [],
      detail: {},
      pageIndex: 0,
      pageSize: 10,
      hasMounted: false,
      codeMap: {
        40019: 1
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user', 'pageReload'])), {}, {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - (2 + 2.6) * fontSize - 130;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_pageReload', '_appointInfo'])), {}, {
    goAppoint: function goAppoint() {
      var router = this.detail.eventTmplId ? 'AppointmentEvent' : 'Appointment';
      this.$router.push({
        name: router,
        query: {
          id: this.detail.service_id,
          productId: this.productId,
          cpId: this.cpId
        }
      });
    },
    // 下拉刷新
    onPulldownLoading: function onPulldownLoading() {
      var _this = this;
      this.loadList(true).then(function () {
        _this.$refs['serviceList'] && _this.$refs['serviceList'].donePulldown();
      });
    },
    // 上拉加载
    onPullupLoading: function onPullupLoading() {
      var _this2 = this;
      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function () {
        _this2.$refs['serviceList'] && _this2.$refs['serviceList'].donePullup();
      });
    }
  }),
  mounted: function mounted() {
    this.hasMounted = true;
  },
  created: function created() {
    var _this3 = this;
    this._appointInfo({
      id: this.id,
      productId: this.productId,
      cpId: this.cpId
    });
    // banner
    apibannerlist({
      type: 3,
      object_id: this.id
    }).then(function (res) {
      if (res.success) _this3.bannerList = res.data;
    });
    apiservicedetail({
      id: this.id
    }).then(function (res) {
      if (res.success) _this3.detail = res.data || {};
    });
    getEnterprises({
      codes: '40019'
    }).then(function (res) {
      if (res.success) {
        res.data.forEach(function (v) {
          _this3.$set(_this3.codeMap, v.code, v.value);
        });
      }
    });
  }
};